// Main JavaScript file

document.addEventListener('DOMContentLoaded', () => {
  console.log('WordPress theme JS loaded successfully!');
  
  // Hamburger menu toggle
  const hamburger = document.querySelector('.js-hamburger');
  const navigation = document.querySelector('.js-nav');
  const overlay = document.querySelector('.js-nav-overlay');
  const body = document.body;
  
  if (hamburger) {
    hamburger.addEventListener('click', () => {
      hamburger.classList.toggle('is-active');
      if (navigation) {
        navigation.classList.toggle('is-active');
      }
      if (overlay) {
        overlay.classList.toggle('is-active');
      }
      body.classList.toggle('is-nav-open');
    });
  }
  
  // Close menu when clicking overlay
  if (overlay) {
    overlay.addEventListener('click', () => {
      if (hamburger) {
        hamburger.classList.remove('is-active');
      }
      if (navigation) {
        navigation.classList.remove('is-active');
      }
      overlay.classList.remove('is-active');
      body.classList.remove('is-nav-open');
    });
  }
  
  // Close menu when clicking outside
  document.addEventListener('click', (e) => {
    if (!hamburger || !navigation) return;
    
    if (!e.target.closest('.l-header__humburger') && !e.target.closest('.l-nav')) {
      hamburger.classList.remove('is-active');
      navigation.classList.remove('is-active');
      if (overlay) {
        overlay.classList.remove('is-active');
      }
      body.classList.remove('is-nav-open');
    }
  });
  
  // Hero slideshow (Ken Burns effect)
  const heroSlideshow = document.querySelector('.js-hero-slideshow');
  if (heroSlideshow) {
    const slides = heroSlideshow.querySelectorAll('.p-top__slideshow-slide');
    let currentSlide = 0;
    const zoomDuration = 5000; // 5秒ズーム
    const fadeDuration = 1500;  // 1.5秒フェード

    const startSlide = (index) => {
      slides[index].classList.add('is-active');
      // ズーム開始を少し遅らせて確実に表示された後にスタート
      requestAnimationFrame(() => {
        slides[index].classList.add('is-zooming');
      });
    };

    const nextSlide = () => {
      const prevIndex = currentSlide;
      currentSlide = (currentSlide + 1) % slides.length;

      // 次のスライドを表示してズーム開始
      startSlide(currentSlide);

      // フェードアウトのタイミングで前のスライドを非表示
      setTimeout(() => {
        slides[prevIndex].classList.remove('is-active', 'is-zooming');
        // ズームをリセット
        slides[prevIndex].querySelector('img').style.transform = '';
      }, fadeDuration);
    };

    // 最初のスライドを開始
    startSlide(0);

    // ズーム完了のタイミングで次のスライドに切り替え
    setInterval(nextSlide, zoomDuration);
  }

  // Header scroll effect
  const header = document.querySelector('.l-header');
  if (header) {
    const scrollThreshold = 100;
    const onScroll = () => {
      if (window.scrollY > scrollThreshold) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Smooth scroll for anchor links
  const anchorLinks = document.querySelectorAll('a[href^="#"]');
  
  anchorLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      const href = link.getAttribute('href');
      
      if (href !== '#' && href !== '#0') {
        const target = document.querySelector(href);
        
        if (target) {
          e.preventDefault();
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    });
  });
  
  // Lightbox functionality
  const lightbox = document.querySelector('.js-lightbox');
  const lightboxImage = document.querySelector('.js-lightbox-image');
  const lightboxTriggers = document.querySelectorAll('.js-lightbox-trigger');
  const sliderLightboxTriggers = document.querySelectorAll('.js-slider-lightbox-trigger');
  const lightboxCloseButtons = document.querySelectorAll('.js-lightbox-close');
  const lightboxPrev = document.querySelector('.js-lightbox-prev');
  const lightboxNext = document.querySelector('.js-lightbox-next');
  
  let currentImages = [];
  let currentIndex = 0;
  let currentImageSet = 'neighborhood'; // 'neighborhood' or 'slider'
  
  // 周辺環境の画像用
  if (lightbox && lightboxTriggers.length > 0) {
    // 画像をクリックしてライトボックスを開く
    lightboxTriggers.forEach((trigger, index) => {
      trigger.addEventListener('click', () => {
        const imageSrc = trigger.dataset.image;
        currentImages = Array.from(lightboxTriggers).map(t => t.dataset.image);
        currentIndex = parseInt(trigger.dataset.index);
        currentImageSet = 'neighborhood';
        
        if (imageSrc && lightboxImage) {
          lightboxImage.src = imageSrc;
          lightbox.classList.add('is-active');
          document.body.style.overflow = 'hidden';
        }
      });
    });
  }
  
  // スライダーの画像用
  if (lightbox && sliderLightboxTriggers.length > 0) {
    sliderLightboxTriggers.forEach((trigger, index) => {
      trigger.addEventListener('click', () => {
        const imageSrc = trigger.dataset.image;
        currentImages = Array.from(sliderLightboxTriggers).map(t => t.dataset.image);
        currentIndex = parseInt(trigger.dataset.index);
        currentImageSet = 'slider';
        
        if (imageSrc && lightboxImage) {
          lightboxImage.src = imageSrc;
          lightbox.classList.add('is-active');
          document.body.style.overflow = 'hidden';
        }
      });
    });
  }
  
  // 店舗リノベーションの画像用
  const renovationLightboxTriggers = document.querySelectorAll('.js-renovation-lightbox');
  if (lightbox && renovationLightboxTriggers.length > 0) {
    renovationLightboxTriggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const imageSrc = trigger.dataset.image;
        // data-indexが重複する可能性があるため、クリック時に全トリガーから画像リストを再構築
        const allTriggers = document.querySelectorAll('.js-renovation-lightbox');
        currentImages = Array.from(allTriggers).map(t => t.dataset.image);
        currentIndex = parseInt(trigger.dataset.index);

        if (imageSrc && lightboxImage) {
          lightboxImage.src = imageSrc;
          lightbox.classList.add('is-active');
          document.body.style.overflow = 'hidden';
        }
      });
    });
  }

  // マンションリノベーションの画像用（Splide clone対応のイベント委譲）
  if (lightbox) {
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('.js-apartment-lightbox');
      if (!trigger) return;

      const imageSrc = trigger.dataset.image;
      // Splide cloneを除外してオリジナルスライドのみから画像リストを構築
      const originalTriggers = Array.from(document.querySelectorAll('.js-apartment-lightbox')).filter(t => !t.closest('.splide__slide--clone'));
      currentImages = originalTriggers.map(t => t.dataset.image);
      currentIndex = parseInt(trigger.dataset.index);

      if (imageSrc && lightboxImage) {
        lightboxImage.src = imageSrc;
        lightbox.classList.add('is-active');
        document.body.style.overflow = 'hidden';
      }
    });
  }

  // 注文住宅の画像用（Splide clone対応のイベント委譲）
  if (lightbox) {
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('.js-order-lightbox');
      if (!trigger) return;

      const imageSrc = trigger.dataset.image;
      const originalTriggers = Array.from(document.querySelectorAll('.js-order-lightbox')).filter(t => !t.closest('.splide__slide--clone'));
      currentImages = originalTriggers.map(t => t.dataset.image);
      currentIndex = parseInt(trigger.dataset.index);

      if (imageSrc && lightboxImage) {
        lightboxImage.src = imageSrc;
        lightbox.classList.add('is-active');
        document.body.style.overflow = 'hidden';
      }
    });
  }

  // 共通のライトボックス機能
  if (lightbox) {
    // ライトボックスを閉じる
    lightboxCloseButtons.forEach(button => {
      button.addEventListener('click', () => {
        lightbox.classList.remove('is-active');
        document.body.style.overflow = '';
      });
    });
    
    // 前の画像
    if (lightboxPrev) {
      lightboxPrev.addEventListener('click', () => {
        if (currentImages.length > 0) {
          currentIndex = (currentIndex - 1 + currentImages.length) % currentImages.length;
          lightboxImage.src = currentImages[currentIndex];
        }
      });
    }
    
    // 次の画像
    if (lightboxNext) {
      lightboxNext.addEventListener('click', () => {
        if (currentImages.length > 0) {
          currentIndex = (currentIndex + 1) % currentImages.length;
          lightboxImage.src = currentImages[currentIndex];
        }
      });
    }
    
    // ESCキーでライトボックスを閉じる
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && lightbox.classList.contains('is-active')) {
        lightbox.classList.remove('is-active');
        document.body.style.overflow = '';
      }
      // 左右キーで画像を切り替え
      if (lightbox.classList.contains('is-active')) {
        if (e.key === 'ArrowLeft' && lightboxPrev) {
          lightboxPrev.click();
        } else if (e.key === 'ArrowRight' && lightboxNext) {
          lightboxNext.click();
        }
      }
    });
  }
  
  // WORKS DESIGN HOUSE スライダー（Splide）- 全セクション対応
  if (typeof Splide !== 'undefined') {
    document.querySelectorAll('.js-works-splide').forEach(el => {
      new Splide(el, {
        type: 'loop',
        perPage: 4,
        gap: '15px',
        padding: { left: '3%', right: '3%' },
        arrows: false,
        pagination: false,
        autoplay: true,
        interval: 4000,
        speed: 600,
        pauseOnHover: true,
        pauseOnFocus: true,
        lazyLoad: 'nearby',
        breakpoints: {
          576: {
            perPage: 1,
            padding: { left: '10%', right: '10%' },
            gap: '10px',
          },
          768: {
            perPage: 2,
            padding: { left: '5%', right: '5%' },
            gap: '12px',
          },
          992: {
            perPage: 3,
            gap: '12px',
          },
        },
      }).mount();
    });

    // 店舗リノベーションスライダー（矢印付き）
    document.querySelectorAll('.js-renovation-splide').forEach(el => {
      new Splide(el, {
        type: 'loop',
        perPage: 4,
        gap: '15px',
        padding: { left: '3%', right: '3%' },
        arrows: true,
        pagination: false,
        autoplay: true,
        interval: 4000,
        speed: 600,
        pauseOnHover: true,
        pauseOnFocus: true,
        lazyLoad: 'nearby',
        breakpoints: {
          576: {
            perPage: 1,
            padding: { left: '10%', right: '10%' },
            gap: '10px',
          },
          768: {
            perPage: 2,
            padding: { left: '5%', right: '5%' },
            gap: '12px',
          },
          992: {
            perPage: 3,
            gap: '12px',
          },
        },
      }).mount();
    });

    // 注文住宅スライダー（矢印付き）
    document.querySelectorAll('.js-order-splide').forEach(el => {
      new Splide(el, {
        type: 'loop',
        perPage: 4,
        gap: '15px',
        padding: { left: '3%', right: '3%' },
        arrows: true,
        pagination: false,
        autoplay: true,
        interval: 4000,
        speed: 600,
        pauseOnHover: true,
        pauseOnFocus: true,
        lazyLoad: 'nearby',
        breakpoints: {
          576: {
            perPage: 1,
            padding: { left: '10%', right: '10%' },
            gap: '10px',
          },
          768: {
            perPage: 2,
            padding: { left: '5%', right: '5%' },
            gap: '12px',
          },
          992: {
            perPage: 3,
            gap: '12px',
          },
        },
      }).mount();
    });

    // マンションリノベーションスライダー（矢印付き）
    document.querySelectorAll('.js-apartment-splide').forEach(el => {
      new Splide(el, {
        type: 'loop',
        perPage: 4,
        gap: '15px',
        padding: { left: '3%', right: '3%' },
        arrows: true,
        pagination: false,
        autoplay: true,
        interval: 4000,
        speed: 600,
        pauseOnHover: true,
        pauseOnFocus: true,
        lazyLoad: 'nearby',
        breakpoints: {
          576: {
            perPage: 1,
            padding: { left: '10%', right: '10%' },
            gap: '10px',
          },
          768: {
            perPage: 2,
            padding: { left: '5%', right: '5%' },
            gap: '12px',
          },
          992: {
            perPage: 3,
            gap: '12px',
          },
        },
      }).mount();
    });

    // 物件詳細スライダー（サムネイル同期付き）
    const detailMain = document.querySelector('.js-detail-splide');
    const detailThumbs = document.querySelector('.js-detail-splide-thumbs');
    if (detailMain && detailThumbs) {
      const mainSlider = new Splide(detailMain, {
        type: 'fade',
        rewind: true,
        pagination: false,
        arrows: true,
        heightRatio: 0.6,
      });
      const thumbSlider = new Splide(detailThumbs, {
        fixedWidth: 100,
        fixedHeight: 60,
        gap: 10,
        rewind: true,
        pagination: false,
        arrows: false,
        isNavigation: true,
      });
      mainSlider.sync(thumbSlider);
      mainSlider.mount();
      thumbSlider.mount();
    }

    // 投資用物件カルーセル（page-income）
    document.querySelectorAll('.js-income-splide').forEach(el => {
      new Splide(el, {
        type: 'loop',
        perPage: 3,
        gap: '20px',
        arrows: true,
        pagination: false,
        autoplay: true,
        interval: 4000,
        speed: 600,
        pauseOnHover: true,
        breakpoints: {
          576: {
            perPage: 1,
            gap: '10px',
          },
          768: {
            perPage: 2,
            gap: '15px',
          },
        },
      }).mount();
    });
  }

  // FAQ Accordion
  const faqQuestions = document.querySelectorAll('.p-top__faq-question');
  const faqMoreBtn = document.querySelector('.p-top__faq-more');
  const faqList = document.querySelector('.p-top__faq-list');
  const faqDots = document.querySelector('.p-top__faq-dots');

  faqQuestions.forEach(question => {
    question.addEventListener('click', () => {
      const item = question.parentElement;
      const isOpen = item.classList.contains('is-open');

      // 他のアイテムを閉じる
      document.querySelectorAll('.p-top__faq-item.is-open').forEach(openItem => {
        openItem.classList.remove('is-open');
      });

      // クリックしたアイテムをトグル
      if (!isOpen) {
        item.classList.add('is-open');
      }
    });
  });

  // View More ボタン
  if (faqMoreBtn && faqList) {
    faqMoreBtn.addEventListener('click', (e) => {
      e.preventDefault();
      faqList.classList.add('is-expanded');
      faqMoreBtn.parentElement.style.display = 'none';
      if (faqDots) {
        faqDots.style.display = 'none';
      }
    });
  }

  // Scroll fade-in animation
  const fadeTargets = document.querySelectorAll('section:not(.p-company__life):not(.p-case__detail):not(.p-news__detail):not(.p-property__tag):not(.p-property__list):not(.p-property__main), .p-top__concept, .l-footer-main__content, .l-footer-main__sns, .l-inquiry');
  if (fadeTargets.length > 0 && 'IntersectionObserver' in window) {
    fadeTargets.forEach(el => {
      el.classList.add('js-fade-in');
    });

    const fadeObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          fadeObserver.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.15,
      rootMargin: '0px 0px -50px 0px'
    });

    fadeTargets.forEach(el => fadeObserver.observe(el));
  }

  // Example of lazy loading images
  const lazyImages = document.querySelectorAll('img[data-src]');
  
  if ('IntersectionObserver' in window) {
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
          imageObserver.unobserve(img);
        }
      });
    });
    
    lazyImages.forEach(img => imageObserver.observe(img));
  } else {
    // Fallback for browsers that don't support IntersectionObserver
    lazyImages.forEach(img => {
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
    });
  }

  // 物件一覧 複数選択フィルター（まとめて絞り込み方式）
  const filterToggles = document.querySelectorAll('.js-filter-toggle');
  const filterSubmit = document.querySelector('.js-filter-submit');

  if (filterToggles.length > 0) {
    // クリックで見た目だけトグル
    filterToggles.forEach(toggle => {
      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        toggle.classList.toggle('active');

        // 「すべて」ボタンのactive状態を更新
        const resetBtn = document.querySelector('.js-filter-reset');
        if (resetBtn) {
          const hasActive = document.querySelector('.js-filter-toggle.active');
          resetBtn.classList.toggle('active', !hasActive);
        }
      });
    });

    // 「絞り込み」ボタンで一括適用
    if (filterSubmit) {
      filterSubmit.addEventListener('click', (e) => {
        e.preventDefault();

        const url = new URL(window.location.origin + window.location.pathname);
        url.pathname = url.pathname.replace(/\/page\/\d+\/?/, '/');

        const taxonomies = {};

        document.querySelectorAll('.js-filter-toggle.active').forEach(el => {
          const tax = el.dataset.taxonomy;
          const slug = el.dataset.slug;
          if (!taxonomies[tax]) taxonomies[tax] = [];
          taxonomies[tax].push(slug);
        });

        Object.keys(taxonomies).forEach(tax => {
          url.searchParams.set(tax, taxonomies[tax].join(','));
        });

        window.location.href = url.toString();
      });
    }
  }
});

// Export for use in other modules if needed
export default {
  init() {
    console.log('Theme initialized');
  }
};
